import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';

export const AuthorInfo = styled.div`
  position: relative;
  flex: 1;
  ${({ small }) => (small ? getFont(-1) : getFont(0))};
`;
